/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicAssessmentDataCollection extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicAssessmentDataCollection");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicAssessmentDataCollection.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicAssessmentDataCollection>): BackgroundJobPayloadForPeriodicAssessmentDataCollection {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicAssessmentDataCollection(), model);
        BackgroundJobPayloadForPeriodicAssessmentDataCollection.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicAssessmentDataCollection>): BackgroundJobPayloadForPeriodicAssessmentDataCollection {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicAssessmentDataCollection.newInstance(<BackgroundJobPayloadForPeriodicAssessmentDataCollection> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicAssessmentDataCollection) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicAssessmentDataCollection.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicAssessmentDataCollection): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicAssessmentDataCollection.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
